import React from "react"
import AnalyticsConsent from "./src/components/AnalyticsConsent"
import { initAnalyticsIfConsented } from "./src/utils/analytics"

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <AnalyticsConsent />
  </>
)

export const onRouteUpdate = ({ location }) => {
  initAnalyticsIfConsented(location.pathname + location.search)
}
